import React from "react";
import { useMemo, useCallback } from "react";

import { LESSON_CONTENTS } from "../../../../constants/active_learning";
import {
  IActiveLearningAnswers,
  IActiveLearningIssue,
} from "../../../../state";
import { Context, updateActiveLearningAnswers } from "../../../../studentStore";
import { getActiveLearningAnswers } from "../../../../libs/ActiveLearning";
import TreeCard from "../../../../atoms/ActiveLearning/TreeCard";
import Header from "../../../../organisms/ActiveLearning/Header";
import EndLesson from "../../../../organisms/ActiveLearning/EndLesson";
import MyData from "../../../../organisms/student/ActiveLearningLessonsMyData";
import Issue1 from "../../../../organisms/student/ActiveLearningLessons/Lesson13/Issue1";
import Issue2 from "../../../../organisms/student/ActiveLearningLessons/Lesson13/Issue2";
import Issue3 from "../../../../organisms/student/ActiveLearningLessons/Lesson13/Issue3";
import Issue4 from "../../../../organisms/student/ActiveLearningLessons/Lesson13/Issue4";
import styles from "../ActiveLearningLesson.module.scss";
import useWaitApiCall from "../../../../hooks/useWaitApiCall";
import SaveAnswerButton from "../../../../atoms/ActiveLearning/SaveAnswerButton";

export const Lesson = () => {
  const { state, dispatch } = React.useContext(Context);
  const [calling, peep] = useWaitApiCall(state);
  const [answers, setAnswers] = React.useState<IActiveLearningAnswers[]>([]);

  React.useEffect(() => {
    setAnswers([...state.active_learning_answers]);
  }, [state.active_learning_answers]);

  const currentActiveLearnig = useMemo(() => {
    return state.active_learning_data_by_lesson;
  }, [state.active_learning_data_by_lesson]);

  const findIssue = useCallback(
    (no: number): IActiveLearningIssue | undefined =>
      currentActiveLearnig.issues?.find(issue => issue.no === no),
    [currentActiveLearnig],
  );

  const saveAnswers = () => {
    const params = answers;
    const { material_code, no } = state.active_learning_data_by_lesson;
    if (calling) return;
    return dispatch(
      peep(
        updateActiveLearningAnswers(material_code, no, JSON.stringify(params)),
      ),
    );
  };

  const lastAnswerQ3 = useMemo(() => {
    const answersByMaterial = state.active_learning_answers_by_material;
    const currentAnswers = getActiveLearningAnswers(answersByMaterial, 2, 3, 1);

    return currentAnswers.map(result => result.value).join("");
  }, [state.active_learning_answers_by_material]);

  return (
    <div className={styles.wrapper} id="accordion">
      {/* <p>answer: {JSON.stringify(answers)}</p> */}
      <Header
        no={currentActiveLearnig.no}
        label={LESSON_CONTENTS.lesson13.label}
        title={currentActiveLearnig.title}
        read={LESSON_CONTENTS.lesson13.read}
      />
      <div className={styles.container}>
        <div className={styles.section}>
          <div className={styles.review}>
            <p className={styles.title}>前回の振り返り</p>
            <TreeCard
              title={"「問い」の原型"}
              text={lastAnswerQ3 || "回答データがありません。"}
            />
          </div>
        </div>
        <div className={styles.section}>
          <Issue1
            issue={findIssue(1)}
            answers={answers}
            setAnswers={setAnswers}
          />
        </div>
        <div className={styles.saveAnswer}>
          <SaveAnswerButton handleClick={saveAnswers} disabled={calling} />
        </div>
        <div className={styles.section}>
          <Issue2
            issue={findIssue(2)}
            answers={answers}
            setAnswers={setAnswers}
          />
        </div>
        <div className={styles.saveAnswer}>
          <SaveAnswerButton handleClick={saveAnswers} disabled={calling} />
        </div>
        <div className={styles.section}>
          <Issue3
            issue={findIssue(3)}
            answers={answers}
            setAnswers={setAnswers}
          />
        </div>
        <div className={styles.saveAnswer}>
          <SaveAnswerButton handleClick={saveAnswers} disabled={calling} />
        </div>
        <div className={styles.section}>
          <Issue4
            issue={findIssue(4)}
            answers={answers}
            setAnswers={setAnswers}
          />
        </div>
        <div className={styles.saveAnswer}>
          <SaveAnswerButton handleClick={saveAnswers} disabled={calling} />
        </div>
        <div className={styles.section}>
          <EndLesson
            text={LESSON_CONTENTS.lesson13.end}
            saveAnswers={saveAnswers}
          />
        </div>
      </div>
      <MyData />
    </div>
  );
};
export default Lesson;
